<h1>Organisation Preferences</h1>

<div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="40px">

  <div fxFlex="grow">
    <organisation-preferences-form [preferences]="preferences$ | async" [loading]="loading$ | async" (submitted)="onSavePreferences($event)"></organisation-preferences-form>
  </div>
  <div fxFlex="grow">

    <ca-branding [branding]="branding$ | async" (colorsSubmitted)="onSaveColors($event)" (imageSubmitted)="onSaveImage($event)"
      (colorsReset)="onColorsReset($event)" (imageRemoved)="onImageRemoved($event)"></ca-branding>
  </div>
</div>